export default {
	/**
	 * We get variants for components
	 * We have to juggle situation when we are using the same components in the Studio as in actual Apps we are building
	 * For this reason, Studio has defined theme on window
	 * Apps will have defined theme in store
	 */
	variants: () => (componentName, variant) => {
		if (window) {
			return window?.COVERGO_STUDIO_THEME?.baseComponentsVariants?.[componentName]?.[variant] || { el: {} }
		}

		return { el: {} }
	},

	locale() {
		return window?.localStorage?.getItem(process.env.VUE_APP_LOCALE_KEY) ?? "en-US"
	},

	localeName: state => locale => {
		return state?.settings?.localesDictionary?.find(item => item.value === locale)?.name
	},

	currencyCodes(state) {
		const dictionary = state?.settings?.currencyCodesDictionary ?? {}
		return Object.keys(dictionary)?.map(key => ({ name: dictionary[key], value: key }))
	}
}
